angular.module('account').controller('AccountSetupCtrl',
    ['$scope', '$stateParams', '$uibModal', '$filter', 'MyChartService', 'ListService', 'toaster', 'aprgettext', '$log', 'TransitionManager',
        function ($scope, $stateParams, $modal, $filter, MyChartService, ListService, toaster, gettext, $log, TransitionManager) {
            'use strict';

            $scope.loading = false;
            $scope.viewSecondaryInsurance = false;
            $scope.createAccountDto = {
                DriversLicenseNumber: '',
                DriversLicenseState: '',
                PrimaryInsurance: {
                    InsuranceProvider: '',
                    InsurancePlan: '',
                    AccountFirstName: '',
                    AccountLastName: '',
                    PolicyNumber: '',
                    GroupNumber: ''
                },
                SecondaryInsurance: {
                    InsuranceProvider: '',
                    InsurancePlan: '',
                    AccountFirstName: '',
                    AccountLastName: '',
                    PolicyNumber: '',
                    GroupNumber: ''
                },
                SecurityQuestions: [
                    {Question: {Id: '', Text: '', DisplayOrder: ''}, Answer: ''},
                    {Question: {Id: '', Text: '', DisplayOrder: ''}, Answer: ''},
                    {Question: {Id: '', Text: '', DisplayOrder: ''}, Answer: ''}
                ]
            };

            ListService.getList('maritalstatuslist', $scope, 'maritalStatusTypes');
            ListService.getList('insurancecarriers', $scope, 'insuranceCarriers');
            ListService.getList('securityquestions', $scope, 'securityQuestions');

            var insurancePlanList = ListService.getList('insuranceplans', $scope, 'insurancePlans');

            $scope.primaryInsuranceImageModel = {
                maxSizeKb : 200,
                selectedFileName : '',
                selectedMimeType : '',
                selectedFileContents : ''
            };

            $scope.secondaryInsuranceImageModel = {
                maxSizeKb : 200,
                selectedFileName : '',
                selectedMimeType : '',
                selectedFileContents : ''
            };


            $scope.updatePrimaryInsuranceList = function updatePrimaryInsuranceList() {
                insurancePlanList.then(function (data) {
                    $scope.primaryInsurancePlansModified = _.filter(data, {InsuranceCarrierId: $scope.createAccountDto.PrimaryInsurance.InsuranceCarrier.Id});
                });
            };
            $scope.updateSecondaryInsuranceList = function updateSecondaryInsuranceList() {
                insurancePlanList.then(function (data) {
                    $scope.secondaryInsurancePlansModified = _.filter(data, {InsuranceCarrierId: $scope.createAccountDto.SecondaryInsurance.InsuranceCarrier.Id});
                });
            };

            $scope.toggleViewSecondaryInsurance = function toggleViewSecondaryInsurance() {
                $scope.viewSecondaryInsurance = !$scope.viewSecondaryInsurance;
            };

            $scope.back = function back() {
                TransitionManager.transition({appRoute: 'accountvalidation'});
            };
            $scope.skip = function skip() {
                TransitionManager.transition({appRoute: 'aprimaconditions'});
            };
            $scope.next = function next() {
                TransitionManager.transition({appRoute: 'aprimaconditions'});
            };
        }]);


